module.exports = __webpack_public_path__ + "templates/fileManagement.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/auth/management/fileManagement/fileManagement.html
// module id = 349
// module chunks = 15